import React from "react"
import { graphql } from "gatsby"
import Seo from "../components/seo"
import ContentLayout from "../components/content-layout"

const pokerrules = ({ data }) => {
  const currentPage = data.wpPage

  return (
    <>
      <Seo post={currentPage} />
      <ContentLayout title={'Poker Rules Overview'} subtitle={'How to play the various poker games available at SwC Poker'}>
        <div className="poker-rules">
          <div className="row">
            {
              data.pokerRules.subCategories.map((category, i) => {
                return (
                  <div className="col-md-6 col-sm-4 item" key={i}>
                    <h4>{category.name}</h4>
                    <div className="links">
                      <ul style={{ padding: '8px 0px', listStyle: 'none' }}>
                        {
                          category.posts.link.map((post, i) => {
                            return (
                              <li key={i}>
                                <a href={post.uri.replace(/\/$/, '').substring(6)} key={post.id}>{post.title}</a>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  </div>
                )
              })
            }
          </div>

        </div>
      </ContentLayout>
    </>
  )
}

export default pokerrules

export const pageQuery = graphql`
query getPokerRulesLinks {
	pokerRules: allWpCategory(
    filter: {wpParent: {node: {slug: {eq: "poker-rules"}}}}
  ) {
    subCategories: nodes {
      name
      slug
      uri
      posts {  
        link: nodes { 
          slug
          title
          uri
        }          
      }
    }
  }  
  wpPage(slug: {eq: "poker-rules"}) {
    title
    content
    uri
    nodeType
    seo {
      title
      metaDesc
      focuskw
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        altText
        sourceUrl
        srcSet
        localFile {
          childImageSharp {
            gatsbyImageData(quality: 100, formats: [AUTO, WEBP, AVIF])
          }
        }
      }     
      twitterTitle
      twitterDescription
      twitterImage {
        altText
        sourceUrl
        srcSet
        localFile {
          childImageSharp {
            gatsbyImageData(quality: 100, formats: [AUTO, WEBP, AVIF])
          }
        }
      } 
      canonical
      cornerstone
      schema {
        articleType
        pageType
        raw
      }
    }
  }    
} 
`